import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/create`;

export const ROUTE: RouteDefinition = `${baseRoute}/create`;

export const URL = (): RouteDefinition => `${baseRoute}/create`;
